import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { J_J_MEDICAL_NAME_LEGACY } from '@/constants/medicalOnDemand';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';

/**
 * Returns the `MOD_DIRECT_TO_MSL`-gated team name. Pass the team's current
 * `name` (or any display name resolved from the inquiry/conversation); the
 * hook substitutes the legacy name when the flag is OFF, and returns
 * `undefined` when there is no name to render.
 */
export function useModTeamName(freshName: string | undefined): string | undefined {
  const isModDirectToMslEnabled = useFeatureFlag(FEATURE_FLAGS.MOD_DIRECT_TO_MSL);

  if (!freshName) {
    return undefined;
  }

  return isModDirectToMslEnabled ? freshName : J_J_MEDICAL_NAME_LEGACY;
}
